var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPediatrics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.4,17.6c0,0-2,0.1-2-1.9l-0.1-7.3h0.8 l0.1,7.1c-0.1,0.7,0.4,1.3,1,1.4h0.2V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.3,17.6c0,0,2,0.1,1.9-2l-0.1-7.3h-0.8 l0.1,7.1c0.1,0.7-0.3,1.3-1,1.4h-0.2L24.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.8,9.8V8.4h-0.5V6.2h1.4c0.5,0,1,0.4,1,1l0,0v2.7L24.8,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M22.7,9.9V8.5h0.5V6.3h-1.4c-0.5,0-1,0.5-1,1l0,0V10L22.7,9.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.3,29.6L12.3,29.6 c-4.1,0-7.4-3.3-7.4-7.4v-0.9c0-4.1,3.3-7.4,7.4-7.4l0,0c4.1,0,7.4,3.3,7.4,7.4v0.9C19.7,26.3,16.4,29.6,12.3,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.5,24.7h-0.2c-2.9,0-5.2-2.3-5.2-5.2l0,0 c0-2.9,2.3-5.2,5.2-5.2h0.2c2.9,0,5.2,2.3,5.2,5.2l0,0C17.7,22.4,15.4,24.7,12.5,24.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3C5",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12,
    cy: 10.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M9.2,9.4c0,0.2-0.2,0.4-0.4,0.4S8.3,9.7,8.3,9.4C8.3,9.1,8.5,9,8.7,9S9.2,9.2,9.2,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.1,9.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4S16.1,9.2,16.1,9.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12.2,
    cy: 14,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12.2,
    cy: 14,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3C5",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.9,3.8c0,0,0.5-1,1.1-0.4 c0,0,0.5,0.6-0.2,1.1c0,0-1.4,0.6-1.8-0.9c0,0-0.3-1.3,1-1.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.4,28.8c-0.4-0.3-0.6-0.8-0.6-1.6v-1.9 h0.9v1.9c0,0.3,0.1,0.6,0.3,0.8s0.7,0.2,0.7,0.2H28c0.5,0,0.6-0.5,0.6-0.6c0-0.2,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.1-0.5-0.1l0,0l0,0 h-2.4c-0.7,0-1.3-0.2-1.6-0.6c-0.3-0.5-0.3-1.1-0.3-1.3v-8h0.9V25c0,0,0,0.4,0.2,0.7c0.2,0.2,0.5,0.3,0.8,0.3h2.3 c0.2,0,0.7-0.1,1.2,0.3c0.4,0.3,0.5,0.8,0.5,1.4l0,0c0,0.6-0.4,1.5-1.5,1.5H13.6C13.5,29.1,12.7,29.1,12.4,28.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12.3,
    cy: 23.4,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2C355E"
    },
    cx: 12.3,
    cy: 23.4,
    r: 1.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPediatrics);
export default __webpack_public_path__ + "static/media/pediatrics.2ffa871840d24a7a9e31787d93f90dcd.svg";
export { ForwardRef as ReactComponent };